import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './invoice.types';

const resourceSelectors = generateResourceSelectors<types.IInvoice>((state) => state.resource.invoice);

export const invoiceSelectors: types.IInvoiceSelectors = {
  ...resourceSelectors,
};
